import React, { useEffect, useState } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { get, post, put } from "../../utility/fetch";
import { formatDate, gender, numberWithCommas } from "../../utility/general";
import Spinner from "../UI/Spinner";
import notification from "../../utility/notification";
import SpeechToTextButton from "../UI/SpeechToTextButton";
import GhostTextCompletion from "../layouts/TextPrediction";

function QueueWalkInModal({ details, labRequest, patientData, closeModal }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [payload, setPayload] = useState()

    const [labTechs, setLabTechs] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedServices, setSelectedServices] = useState();
    const [labServices, setLabServices] = useState([]);
    const [view, setView] = useState('reg')
    const [activeId, setActiveId] = useState(0)
    const [active, setActive] = useState(0)
    const [walkInInfo, setWalkInInfo] = useState([])
    const [fade, setFade] = useState("fade-in");
    const { patientInfo } = usePatient()
    const navigate = useNavigate()

    console.log(details)
    console.log(labRequest)

    const openModal = () => {
        setIsModalOpen(true);
    };


    const handleServiceChange = (value) => {
        setPayload((prev) => ({
            ...prev,
            walkInTestRequests: value?.map((item) => ({
                internalLabServiceId: item?.value
            }))
        }));
    }

    const getLabServices = async () => {
        let res = await get(`/internallabservice/list/1/1000`);
        setLabServices(res?.data?.recordList.map((service) => (
            {
                label: service?.name,
                value: service?.id,
                amount: service?.cost,
            }
        )))
        console.log(res);
    }

    const handleLabTechChange = (event) => {
        console.log(event)
        setSelectedServices(event?.value);
        // setPayload({...payload, labTechnicianId: event.target.value });
    };

    const getlabtech = async () => {
        const response = await axios.get(`${process.env.REACT_APP_SERVICES_URL}/profile/profilebyhealthcareproviderid/${2}`);
        console.log(response);
        // const data = await response.json()
        setLabTechs(response.data);
        // return data;

    }



    const submitOrder = async () => {
        setLoading(true);
        try {
            let res = await put(`/walkinlabrequest/${walkInInfo?.id}/pay-cash-for-walk-in-lab-service`,
                {
                    labServices: walkInInfo?.walkInTestRequests?.map((request) => ({
                        walkInTestRequestId: request?.id,
                        amount: request?.cost
                    }))
                }
            );
            if (res.statusCode === 200) {
                console.log(res);
                notification({ message: res?.data?.message, type: "success" });
                setLoading(false);
                navigate('/procedures');
                closeModal();
                // setIsModalOpen(true);
            }
            console.log(res);
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
    }





    const submitInternalLabRequest = async () => {
        setLoading(true);



        try {
            let labRequest = await post(`/walkinlabrequest`, {walkInpatientId: patientData?.id});
            console.log(labRequest);
            console.log(payload);
            let res = await put(`/walkinlabrequest/${labRequest?.data?.walkInLabRequestId}/queue-in-lab-services`, {
                walkInTestRequests: payload?.walkInTestRequests?.map((item) => ({
                    internalLabServiceId: item?.internalLabServiceId,
                    weight: payload?.weight,
                    additionalNote: payload?.additionalNote,
                    severity: payload?.severity,
                }))
            });
            if (res?.statusCode === 200) {
                console.log(res)
                getWalkInInfo(res?.data?.walkInLabRequestId)
                openModal();
                setLoading(false);
            }
            else {
                setLoading(false);
                console.log(res)
            }
            console.log(res);
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
        setLoading(false)
    }

    const handleActive = (active) => {
        setActiveId(active?.id);
        setActive(active);
    }

    useEffect(() => {
        getlabtech();
        getLabServices();

        if (patientData) {
            setPayload((prev) => ({
                firstName: patientData.firstName,
                lastName: patientData.lastName,
                gender: patientData?.gender,
                dateOfBirth: patientData?.dateOfBirth,
                email: patientData?.email,
                phoneNumber: patientData?.phoneNumber,
            }));
        }

    }, []);


    const onTranscript = (transcript) => {
        setPayload((prev) => ({
            ...prev,
            additionalNote: payload?.additionalNote + " " + transcript
        }));
    }


    const getWalkInInfo = async (id) => {
        let res = await get(`/walkinlabrequest/${id}`);
        setWalkInInfo(res?.data);
        console.log(res);
    }

    const close = () => {
        setIsModalOpen(false);
        setFade("fade-out");
        closeModal();

        // setTimeout(() => {
        //     // setView("order");
        //     setFade("fade-in");
        // }, 300);

    };

    const handleChange = (e) => {
        if (e.target.name === 'severity' || e.target.name === 'weight') {
            setPayload((prev) => ({
                ...prev,
                [e.target.name]: Number(e.target.value)
            }))
        }
        else {
            setPayload((prev) => ({
                ...prev,
                [e.target.name]: e.target.value
            }))
        }
    }

    console.log(walkInInfo?.walkInTestRequests)

    console.log(walkInInfo?.walkInTestRequests?.reduce((acc, curr) => acc + curr?.cost, 0))

    const handleTranscript = (transcript) => {
        setPayload(prevPayload => ({ ...prevPayload, additionalNote: prevPayload.additionalNote ? prevPayload.additionalNote + ' ' + transcript : transcript }));
    };

    // --- inline styles only ---
    const overlayStyle = {
        position: 'fixed',
        inset: 0,
        background: 'rgba(6,8,15,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1200,
        padding: 20,
    };

    const cardStyle = {
        width: 'min(980px, 96%)',
        maxHeight: '90vh',
        overflowY: 'auto',
        background: '#ffffff',
        borderRadius: 14,
        boxShadow: '0 18px 50px rgba(2,6,23,0.2)',
        padding: 20,
        fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
        border: '1px solid rgba(15,23,42,0.06)',
    };

    const headerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 14,
    };

    const titleStyle = {
        margin: 0,
        fontSize: 20,
        fontWeight: 700,
        color: '#0b1220',
        letterSpacing: 0.2,
    };

    const closeBtnStyle = {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: '#475569',
        width: 40,
        height: 40,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
    };

    const isMobile = window.innerWidth < 768;

    const formContainer = {
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(12, 1fr)',
        gap: 12,
        alignItems: 'start',
    };

    const twoCol = { gridColumn: 'span 6' };
    const fullCol = { gridColumn: '1 / -1' };

    const sectionCard = {
        background: '#fbfdff',
        padding: 14,
        borderRadius: 10,
        border: '1px solid rgba(15,23,42,0.04)',
        boxShadow: '0 6px 18px rgba(2,6,23,0.03)',
    };

    const divider = { height: 12 };

    const submitBtn = {
        minWidth: 160,
        padding: '10px 16px',
        borderRadius: 10,
        border: 'none',
        background: 'green',
        color: '#fff',
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: '0 10px 30px rgba(14,165,162,0.12)',
    };

    const secondaryBtn = {
        minWidth: 120,
        padding: '10px 14px',
        borderRadius: 10,
        border: '1px solid rgba(15,23,42,0.08)',
        background: 'red',
        color: 'white',
        cursor: 'pointer',
        fontWeight: 700,
    };

    const servicePill = (active) => ({
        padding: '10px 12px',
        borderRadius: 10,
        background: active ? 'linear-gradient(90deg,#06b6d4,#10b981)' : '#fff',
        color: active ? '#fff' : '#0b1220',
        border: active ? 'none' : '1px solid rgba(15,23,42,0.06)',
        marginRight: 8,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        boxShadow: active ? '0 8px 20px rgba(6,182,212,0.12)' : 'none'
    });

    return (
        <div style={overlayStyle}>
            <div style={cardStyle} role="dialog" aria-modal="true">
                <div style={headerStyle}>
                    <h2 style={titleStyle}>{view === "reg" ? "Patient Details" : "Order Request"}</h2>
                    <button aria-label="Close modal" onClick={closeModal} style={closeBtnStyle}>
                        <RiCloseFill size={20} />
                    </button>
                </div>

                {view === 'reg' ? (
                    <div style={{ ...formContainer }}>
                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={patientData?.firstName || ''} name="firstName" label="First Name*" />
                        </div>
                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={patientData?.lastName || ''} name="lastName" label="Last Name*" />
                        </div>

                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={patientData?.gender || ''} name="gender" type="text" label="Gender*" options={gender} />
                        </div>
                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={formatDate(patientData?.dateOfBirth) || ''} name="dateOfBirth" dateRestriction={'past'} type="date" label="Date Of Birth*" />
                        </div>

                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={patientData?.email || ''} name="email" label="Email" />
                        </div>
                        <div style={twoCol}>
                            <TagInputs disabled onChange={handleChange} value={patientData?.phoneNumber || ''} name="phoneNumber" label="Phone Number*" />
                        </div>

                        <div style={twoCol}>
                            <TagInputs variation="number" onChange={handleChange} value={payload?.weight || ''} name="weight" label="Weight (Kg)" />
                        </div>
                        {/* <div style={twoCol}>
                            <TagInputs variation="number" onChange={handleChange} value={payload?.severity || ''} name="severity" label="Severity*" />
                        </div> */}

                        <div style={fullCol}>
                            <div style={{ marginBottom: 8, color: '#475569', fontSize: 13, fontWeight: 600 }}>Lab Services</div>
                            <div style={sectionCard}>
                                <TagInputs isMulti label="Select Lab Services" onChange={handleServiceChange} options={labServices} name="walkInTestRequests" type='R-select' />
                            </div>
                        </div>

                        <div style={fullCol}>
                            <div style={{ marginBottom: 8, color: '#475569', fontSize: 13, fontWeight: 600 }}>Additional Notes</div>
                            <div style={sectionCard}>
                                <GhostTextCompletion label="Additional Notes" handleChange={handleChange} type='textArea' name="additionalNote" value={payload?.additionalNote} multiline />
                            </div>
                            <div>
                                <SpeechToTextButton onTranscript={onTranscript} />
                            </div>
                        </div>

                        <div style={{ ...fullCol, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 6 }}>
                            
                            <div style={{ display: 'flex', gap: 12 }}>
                                <button onClick={closeModal} style={secondaryBtn}>Cancel</button>
                                <button disabled={loading} onClick={submitInternalLabRequest} className="btn" style={submitBtn}>
                                    {loading ? <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>Proceed &nbsp; <Spinner width={20} height={20} /></span> : 'Proceed With Request'}
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12,1fr)', gap: 12 }}>
                        <div style={{ gridColumn: '1 / -1' }}>
                            <div style={{ marginBottom: 12 }}>
                                {walkInInfo?.walkInTestRequests
                                    ?.filter((test) => (test?.isPaid === false))
                                    ?.map((test) => (
                                        <div key={test?.id} onClick={() => handleActive(test)} style={{ marginBottom: 8 }}>
                                            <div style={servicePill(activeId === test?.id)}>
                                                {test?.internalLabService?.name}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div style={{ gridColumn: '1 / -1', ...sectionCard }}>
                            <div style={{ marginBottom: 10 }}>
                                <TagInputs label="Select Lab Service" onChange={handleServiceChange} options={labServices} name="referredClinicId" type='R-select' />
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <TagInputs label="Amount" value={numberWithCommas(walkInInfo?.walkInTestRequests?.reduce((acc, curr) => acc + curr?.cost, 0))} readOnly />

                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <SpeechToTextButton onTranscript={handleTranscript} />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button disabled={loading} onClick={submitOrder} style={submitBtn}>
                                    {loading ? <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>Place order &nbsp; <Spinner width={20} height={20} /></span> : 'Place Order'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isModalOpen &&
                    <SuccessModal message={"Walk In Lab Request Created Successfully"} Name={`${details?.firstName} ${details?.lastName}`} closeModal={close} />
                }
            </div>
        </div>
    );
}

export default QueueWalkInModal;
